module.exports = __webpack_public_path__ + "static/img/zsmj1.4b4f232.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/zsmj1.jpg
// module id = K0Le
// module chunks = 0